import React from "react";
import logo from "../../assets/images/logo_round.svg";
import { CircularProgress } from "@material-ui/core";
import { useSelector } from "react-redux";
import { IAppState } from "../../redux/types";

const ConditionalPreloader = ({
  fromWhom,
}: {
  fromWhom?: string;
}): JSX.Element => {
  const { isShow } = useSelector((state: IAppState) => state.preloader);

  return isShow ? <Preloader fromWhom={fromWhom} /> : null;
};
export const Preloader = React.memo(
  ({ fromWhom }: { fromWhom?: string }): JSX.Element => {
    return (
      <div className="preloader-page">
        {fromWhom && <h3>{fromWhom}</h3>}
        <div className={"center"} style={{ width: "50px", height: "50px" }}>
          <img src={logo} width={44} height={44} alt="logo" />
          <CircularProgress
            className="preloader-element"
            color="primary"
            size={54}
          />
        </div>
      </div>
    );
  }
);
Preloader.displayName = "Preloader";
export default React.memo(ConditionalPreloader);
